import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { ElementType, ReactNode } from 'react';
import styles from './Container.module.scss';
export type ContainerAs = 'div' | 'section' | 'article' | 'main';

/**
 * Inline padding. `default`: 64px from 1200px, 32px below it, 20px below
 * 768px (the redesign's page gutter). `md`: 60px from 768px, 20px below it
 * (D15, Design's). `compact`: 20px. `editorial`: 96px from 1200px and the
 * default gutter below it (the redesign's editorial gutter). `none`: 0.
 */
export type ContainerGutters = 'default' | 'md' | 'compact' | 'editorial' | 'none';

/**
 * Max width. Against the redesign's container: `default` (1728px) is its
 * `wide`, `md` (1124px) its `content`, `sm` (848px) its `text` and `full` its
 * `full`. `wide` (1380px) and `panel` (1260px) have no redesign twin.
 */
export type ContainerWidth = 'default' | 'wide' | 'md' | 'sm' | 'panel' | 'full';
export interface ContainerProps {
  as?: ContainerAs;
  children: ReactNode;
  gutters?: ContainerGutters;
  width?: ContainerWidth;
}
function Container(t0) {
  const $ = _c(7);
  const {
    as: t1,
    children,
    gutters: t2,
    width: t3
  } = t0;
  const as = t1 === undefined ? "div" : t1;
  const gutters = t2 === undefined ? "default" : t2;
  const width = t3 === undefined ? "default" : t3;
  const Component = as as ElementType;
  const t4 = styles[`helios-container--gutters-${gutters}`];
  const t5 = styles[`helios-container--width-${width}`];
  let t6;
  if ($[0] !== t4 || $[1] !== t5) {
    t6 = classNames(styles["helios-container"], t4, t5);
    $[0] = t4;
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== Component || $[4] !== children || $[5] !== t6) {
    t7 = <Component className={t6}>{children}</Component>;
    $[3] = Component;
    $[4] = children;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
}
export default Container;